import { connect } from 'react-redux';
import React, { Component } from "react";
import ReactTable from "react-table";
import { Card, CardBody, CardHeader, CardTitle, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { PanelHeader } from "components";
import Button from "components/CustomButton/CustomButton.jsx";
import { Link } from 'react-router-dom';
import SweetAlert from "react-bootstrap-sweetalert";
import ButtonWithTooltip from '../../components/Custom/ButtonWithTooltip';
import { loopbackActions } from 'actions';
import ErrorModal from "../Components/ErrorModal"
import Clearfix from "../../components/Custom/Clearfix";
import Loader from "../Components/Loader";
import { selectedProjectChangeListeners } from '../../components/Header/Header';
import { withTranslation } from 'react-i18next';

class Luminares extends Component {

  constructor(props) {
    super(props);

    this.state = {
      alert: null,
      error: null
    }

    selectedProjectChangeListeners.push( ()=>{
      this.fetchData();
    });

  }

  componentWillMount() {
    this.fetchData();
  }

  fetchData() {
    const { dispatch } = this.props;
    dispatch(loopbackActions.list('plant', 'luminares'));
  }


  deleteConfirm(id) {
    const { t } = this.props;
    this.setState({
      alert: (
        <SweetAlert
          warning
          customClass="custom-sweet-alert"
          style={{ display: "block" }}
          title={t("Cancellazione del corpo illuminante")}
          onConfirm={() => {
            const { dispatch } = this.props;
            if (id) {
              dispatch(loopbackActions._delete('plant', 'luminares', id));
              this.setState({
                alert: null
              });
            }
          }}
          onCancel={() => {
            this.setState({
              alert: null
            });
          }}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText={t("SI")}
          cancelBtnText={t("NO")}
          showCancel
        >
          {t("Sei sicuro?")}
          
          </SweetAlert>
      )
    });
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.luminares && nextProps.luminares.error) {
      this.setState({ error: nextProps.luminares.error });
    }
  }

  buildData() {
    const { t,luminares } = this.props;
    let data = [];
    if (luminares && luminares.instances) {

      data = luminares.instances.map((instance, key) => {

        return {
          index: key,
          ...instance,

          actions: (
            <div className="actions-right">
              <Link to={"/luminares/edit/" + instance.id} >
                <ButtonWithTooltip
                  id={"editLuminare_" + instance.id}
                  color="warning"
                  size="sm"
                  tooltipText={t("Modifica")}
                >
                  <i className="fa fa-edit" />
                </ButtonWithTooltip>
              </Link>
              {" "}
              <ButtonWithTooltip
                id={"deleteConfirmLuminare_" + instance.id}
                onClick={() => {
                  this.deleteConfirm(instance.id);
                }}
                color="danger"
                size="sm"
                tooltipText={t("Elimina")}
              >
                <i className="fa fa-times" />
              </ButtonWithTooltip>
              {" "}
            </div>
          )
        };
      })
    }
    return data;
  }

  render() {

    const { error } = this.state;
    
    const { luminares, t } = this.props;

    let loading = luminares && luminares.loading;

    let data = this.buildData();

    return (
      <div>
        {this.state.alert}
        <PanelHeader size="sm" />
        {error && <ErrorModal error={error} onClickHandler={() => { this.setState({ error: null }) }} />}
        <div className="content">
          <Row>
            <Col xs={12} md={12}>
              <Card>
                <CardHeader>
                  <CardTitle>
                    {t("Elenco corpi illuminanti")}
                    <span className="pull-right">
                      {this.props.additionalTopButtons}
                      {
                        !this.props.hideNewButton &&
                        <Link onClick={this.props.onClickNew ? this.props.onClickNew : () => { }}
                          to={"/luminares/edit/0"}
                          className="custom-display-inline-block custom-v-align-top">
                          <Button color="primary" round size="sm" className="custom-no-margin">{t("Nuovo")}</Button>
                        </Link>
                      }
                    </span>
                    <Clearfix />
                  </CardTitle>
                </CardHeader>
                <CardBody>

                  <ReactTable
                    data={data}
                    className="-striped -highlight"
                    previousText={t("Precedente")}
                    nextText={t('Successiva')}
                    noDataText={loading ? '' : t('Nessun risultato')}
                    pageText={t('Pagina')}
                    ofText={t('di')}
                    rowsText={t('righe')}
                    LoadingComponent = { () => <Loader loading={loading} /> }
                    columns={[
                      {
                        Header: t("Tipo"),
                        accessor: "type",
                        Filter: ({filter, onChange}) => (
                          <input
                            onChange={event => onChange(event.target.value)}
                            value={filter ? filter.value : ''}
                            placeholder={t("Search...")}
                            style={{
                              width: '100%'
                            }}
                          />
                        ),
                        filterable: true
                      },
                      {
                        Header: t("Produttore"),
                        accessor: "producer",
                        Filter: ({filter, onChange}) => (
                          <input
                            onChange={event => onChange(event.target.value)}
                            value={filter ? filter.value : ''}
                            placeholder={t("Search...")}
                            style={{
                              width: '100%'
                            }}
                          />
                        ),
                        filterable: true
                      },
                      {
                        Header: t("Modello"),
                        accessor: "model",
                        Filter: ({filter, onChange}) => (
                          <input
                            onChange={event => onChange(event.target.value)}
                            value={filter ? filter.value : ''}
                            placeholder={t("Search...")}
                            style={{
                              width: '100%'
                            }}
                          />
                        ),
                        filterable: true
                      },
                      {
                        Header: t("Ottiche"),
                        accessor: "optics",
                        Filter: ({filter, onChange}) => (
                          <input
                            onChange={event => onChange(event.target.value)}
                            value={filter ? filter.value : ''}
                            placeholder={t("Search...")}
                            style={{
                              width: '100%'
                            }}
                          />
                        ),
                        filterable: true
                      },
                      {
                        Header: t("Azioni"),
                        accessor: "actions",
                        sortable: false,
                        filterable: false,
                        resizable: false
                    }
  
                    ]}
                    defaultPageSize={10}
                  />
                </CardBody>
              </Card>



            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { authentication, loopback } = state;
  return {
    authentication,
    luminares: loopback.luminares
  };
}

const connectedLuminares = withTranslation()(connect(mapStateToProps)(Luminares));
export { connectedLuminares as Luminares }; 


// WEBPACK FOOTER //
// ./src/views/Luminares/Luminares.jsx